// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_OCX","right":"styles_right__3dMp5"};